module.exports = __webpack_public_path__ + "static/media/Komala_gaussian2.41f226bd.png";